<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="max-width:800px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"]["PAMAM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeApproval()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="12" class="form-group">
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["G"]}}* :</label>
                                        <customtreeselect :multiple="false"
                                                          :options="dd_agentgroup"
                                                          :flat="true"
                                                          :disabled="true"
                                                          :clearable="false"
                                                          :defaultExpandLevel="Infinity"
                                                          @input="AgentGroupChange"
                                                          :placeholder="getLanguage['AG']['G']"
                                                          v-model="arr_FV['AGI']" />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{getLanguage["MEM"]["BAN"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_membankname"
                                                    :auto-load-root-options="convertToBool(obj_ad.AN > 0)"
                                                    v-model="obj_ad['AN']"
                                                    :clearable="false"
                                                    :disabled="true"
                                                    value-consists-of="LEAF_PRIORITY"/>
                                        <span class="ErrMsg">{{ ValidationErrMsg('AN','BAN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["U"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :async="true"
                                                    :load-options="loadMemberOptions"
                                                    :options="ddMemberList"
                                                    :defaultOptions="ddDefaultMemberList"
                                                    :auto-load-root-options="convertToBool(searchUserId > 0)"
                                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                    :placeholder="this.utilGetDDLanguage('MEM.U')"
                                                    :cacheOptions="false"
                                                    v-model="searchUserId" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('MI') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol>
                                        <label class="col-form-label-sm">
                                            {{getLanguage["BS"]["TRSA"]}} :
                                            <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                        </label>
                                        <CInput size="sm"
                                                :prepend="obj_ad.FCS === obj_ad.ISOC ? obj_ad.FCS : obj_ad.TCS"
                                                vertical
                                                :value="obj_ad.TA ? ThousandSeparator(obj_ad.TA, getThousandCurrency ? 3 : 2) : '0.00'"
                                                :placeholder="getLanguage['BS']['TRSA']"
                                                :disabled="true"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm mandatory_Field" v-if="obj_ad.FCS == obj_ad.ISOC">
                                            {{ getLanguage["BETRPT"]["DA"] }} : {{ obj_ad.TCS }} {{ ThousandSeparator(obj_ad.FDA, getThousandCurrency ? 3 : 2) }}
                                            <br />
                                            {{ getLanguage["MTA"]["RATE"] }} : {{ formatNumber(obj_ad.FER, 0, obj_ad.FCS) }} = {{obj_ad.TCS }} {{ obj_ad.TER }}
                                        </label>
                                        <label class="col-form-label-sm mandatory_Field" v-else>
                                            {{ getLanguage["BETRPT"]["DA"] }} : {{ obj_ad.FCS }} {{ ThousandSeparator(obj_ad.FDA, getThousandCurrency ? 3 : 2) }}
                                            <br />
                                            {{ getLanguage["MTA"]["RATE"] }} : {{ formatNumber(obj_ad.FER, 0, obj_ad.FCS) }} = {{obj_ad.TCS }} {{ obj_ad.TER }}
                                        </label>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <CTextarea rows="7" size="sm" v-model="obj_ad['R']" />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="approveDeposit()"> {{this.getLanguage['GL']['APR'] }} </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["BS"]["BS"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["G"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :clearable="false"
                                            :defaultExpandLevel="Infinity"
                                            @input="AgentGroupChange"
                                            :placeholder="getLanguage['AG']['G']"
                                            v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["BS"]["BA"]}} :<span class="required" /></span>
                                <treeselect :multiple="false"
                                            :options="dd_bankaccount"
                                            :clearable="false"
                                            :placeholder="getLanguage['BS']['BA']"
                                            v-model="arr_FV['BAI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["GL"]["S"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_status"
                                            :clearable="true"
                                            :placeholder="this.utilGetDDLanguage('GL.S')"
                                            v-model="arr_FV['RS']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["BS"]["MA"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_manualApprove"
                                            :clearable="true"
                                            :placeholder="this.utilGetDDLanguage('BS.MA')"
                                            v-model="arr_FV['MA']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["BS"]["BS"] }}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["BS"]["CHN"] }}<i @click="setSortTable('C')" :class="setSortLogo('C')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["BS"]["TRSDT"] }}<i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["BS"]["TRSA"] }}<i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["BS"]["TRST"] }}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["BS"]["MB"] }}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["BS"]["PF"] }}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["MTA"]["PT"] }}<i @click="setSortTable('D')" :class="setSortLogo('D')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.add)">{{this.getLanguage["GL"]["S"]}}</th>
                                <th>{{ this.getLanguage["MEM"]["BR"] }}<i @click="setSortTable('R')" :class="setSortLogo('D')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_BankStatement.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_BankStatement" :class="getMemberDepositClass(data.MB, data.TA, data.DMI, data.RS)">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>{{ data.C }}</td>
                            <td>{{ formatDateTime(data.TD, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td class="tableCtnRight">
                                <span v-if="data.PM != 7 && data.PM != 11 && !data.FCS" :style="[renderActivityStyle(1),{display:'block'}]">
                                    {{ formatNumber(data.TA, 2, data.CS) }}
                                </span>
                                <span v-else-if="data.FCS" :style="[renderActivityStyle(1),{display:'block'}]">
                                    <span :style="[renderActivityStyle(1)]">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                    <span class="custom_tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="tooltiptext2 promotion-amount-tooltip" style="width:220px">
                                            <template>
                                                <span class="d-flex">
                                                    <span class="tooltip-label">{{getLanguage["BETRPT"]["DA"]}} : </span>
                                                    <span class="tooltip-val">
                                                        {{ formatNumber(data.FDA, 2, data.ISOC == data.TCS ? data.FCS : data.TCS) }}
                                                    </span>
                                                </span>
                                                <span class="d-flex">
                                                    <span class="tooltip-label">{{getLanguage["MTA"]["RATE"]}} : {{ formatNumber(data.FER, 0, data.FCS) }} =</span>
                                                    <span class="tooltip-val"> {{data.TCS}} {{ data.TER }}</span>
                                                </span>
                                            </template>
                                        </span>
                                    </span>
                                </span>
                                <span v-else-if="data.PM == 7" :style="[renderActivityStyle(1),{display:'block'}]">
                                    <span class="grid-line" :style="[renderActivityStyle(1),{display:'block'}]">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                    <span class="grid-line" :style="[renderActivityStyle(1),{display:'block'}]">{{ data.CoinValue }}</span>
                                </span>
                            </td>
                            <td>{{ data.TT }}</td>
                            <td>{{ data.U }}</td>
                            <td>
                                <span class="grid-line" v-if="data.MB==null">{{ data.AN }}</span>
                                <span class="grid-line">{{ data.MB }}</span>
                                <span class="grid-line">{{ data.MBA }}</span>
                                <span class="grid-line">{{ data.MBN }}</span>
                            </td>
                            <td>
                                <span class="grid-line" v-if="data.BN==null">-</span>
                                <span class="grid-line">{{ data.BN }}</span>
                                <span class="grid-line">{{ data.BA }}</span>
                                <span class="grid-line">{{ data.BAN }}</span>
                            </td>
                            <td v-if="checkModuleAccess2(constAccessType.add) && data.TA > 0">
                                <CDropdown :ref="'dd_status_' + index"
                                           :toggler-text="renderStatus(data.RS)"
                                           :color="renderStatusColor(data.RS)"
                                           size="sm"
                                           class="m-1 d-inline-block"
                                           v-if="data.RS==1">
                                    <CDropdownItem @click="changeApproval(true,data,index)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                    <CDropdownItem @click="changeApproval(false,data,index)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                </CDropdown>
                                <span v-else :class="renderStatusColor(data.RS)">{{ renderStatus(data.RS) }}</span>
                            </td>
                            <td v-else></td>
                            <td>{{ data.R }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import { required } from 'vuelidate/lib/validators'
    import Vue from 'vue'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "TD", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                arr_FV: {
                    "DR": {
                        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                        endDate: this.getTodayEndDate()
                    },
                    "AGI": null,
                    "BAI": null
                }, //Filter Value
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                arr_BankStatement: [],

                dd_agentgroup: [],
                dd_bankaccount: [],

                str_agi: "",
                constAccessType: constAccessType,
                ddDefaultMemberList: [],
                ddMemberList: [],
                bool_isAMV: false,
                searchUserId: null,
                searchAgi: 0,
                cuid: "",
                bool_CV: false,
                obj_ad: {
                    BSI: 0,
                    UTS: null,
                    MI: 0,
                    MBAI: null,
                    AN: null
                },
                dd_membankname: [],
                dd_status: [],
                dd_manualApprove: [
                    {
                        id: "1",
                        label: "Yes"
                    },
                    {
                        id: "0",
                        label: "No"
                    }],
            }
        },
        validations: {
            obj_ad: {
                MI: { required },
                AN: { required },
                BSI: { required }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
        },
        watch: {
            getLanguage() {
                this.getStatusList();
            },
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getBankStatementList();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('DDU', 'D', type);
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            renderStatusColor(int_status) {
                switch (int_status) {
                    case 2:
                        return "success";
                        break;
                    case 3:
                        return "danger";
                        break;
                    default:
                        return "dark";
                        break;
                }
            },
            changeApproval(bool_isApproved, d, index) {
                this.bool_CV = false;
                if (bool_isApproved) {
                    this.searchAgi = d.AGI;
                    this.cuid = d.DMI;
                    this.bankaccnum = d.AN;
                    this.obj_ad = {
                        BSI: d.I,
                        UTS: d.UTS,
                        MI: 0,
                        MBAI: null,
                        TA: d.TA,
                        FCS: d.FCS,
                        FDA: d.FDA,
                        FER: d.FER,
                        TCS: d.TCS,
                        TER: d.TER,
                        R: d.R,
                        AN: d.AN,
                        ISOC: d.ISOC
                    };

                    this.dd_membankname = [{ id: d.AN, label: d.AN }];

                    this.searchUserId = null;

                    var that = this;
                    if (this.bankaccnum != null && this.bankaccnum != "") {
                        this.bool_fullLoading = true;

                            this.getDataApi(`/api/dd/memberlistbybankaccno/${this.obj_ad.AN}/${this.searchAgi}`,
                            function (d, s) {
                                if (s && d && d.dropdownlist) {
                                    that.ddMemberList = d.dropdownlist;
                                    that.ddDefaultMemberList = d.dropdownlist;
                                    if (d.dropdownlist && d.dropdownlist.length > 0) {
                                        that.searchUserId = d.dropdownlist[0].id;
                                        that.obj_ad.MI = d.dropdownlist[0].id;
                                    }
                                    that.$forceUpdate();
                                }
                                else {
                                    that.ddDefaultMemberList = [];
                                }

                    that.bool_fullLoading = false;
                    that.bool_isAMV = true;
                    });

                    }
                    else {
                        this.bool_isAMV = true;
                        this.ddDefaultMemberList = [];
                    }
                } else {
                    this.$fire({
                        title: this.getLanguage["BS"]["CR"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;

                            this.bool_fullLoading = true;

                            let obj_bs = {
                                "BSI": d.I,
                                "IA": false,
                                "UTS": d.UTS
                            }

                            this.postDataApi(`/api/bankacc/ap`, obj_bs,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.getBankStatementList();
                                    }
                                });
                        }
                    });
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;

                searchQuery = encodeURIComponent(searchQuery);

                this.getDataApi(`/api/dd/memberlistbybankaccno/${this.obj_ad.AN}/${this.searchAgi}/${searchQuery}/${this.obj_ad['BSI']}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddMemberList = d.dropdownlist;
                        }
                        else {
                            that.ddMemberList = [];
                        }

                        callback(null, that.ddMemberList);
                    });
            },
            closeApproval() {
                this.bool_isAMV = false;
                this.bool_CV = false;
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {
                    var validateObj = this.$v.obj_ad[value];

                    if (value == "MI" && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MEM"]["U"]);
                    }
                    else if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }

                }

            },
            approveDeposit() {
                this.bool_CV = true;

                this.obj_ad["MI"] = this.searchUserId;

                this.$v.obj_ad.$touch();
                if (!this.$v.obj_ad.$error) {
                    this.$fire({
                        title: this.getLanguage["BS"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;

                            this.bool_fullLoading = true;
                            this.obj_ad["IA"] = true;


                            this.postDataApi(`/api/bankacc/ap`, this.obj_ad,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.bool_isAMV = false;
                                        that.getBankStatementList();
                                    }
                                });
                        }
                    });
                }
            },
            newSearch() {
                //if (!this.bool_isAMV) {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getBankStatementList();
                //}
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getBankStatementList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList(loadList) {
                var that = this;
                this.bool_fullLoading = true;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = d.dropdownlist;

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                            var agiResult = that.recursiveSeach(that.dd_agentgroup, that.arr_FV.AGI);

                            if (!agiResult) {
                                that.arr_FV.AGI = null;
                                that.bool_fullLoading = false;
                            }
                            else
                                that.loadBankAccount(loadList);
                        }
                    });
            },
            loadBankAccount(loadList) {
                this.dd_bankaccount = [];

                if (this.arr_FV.AGI != null && this.arr_FV.AGI.indexOf("-") >= 0) {

                    var that = this;
                    var agi = that.arr_FV.AGI.split("-");

                    this.getDataApi(`/api/dd/adbacc/` + agi[1],
                        function (d, s) {
                            if (s) {
                                that.dd_bankaccount = d.dropdownlist;

                                if (loadList)
                                    that.getBankStatementList();
                            }
                        });
                }
            },
            recursiveSeach(obj, searchVal) {
                if (obj != null && obj.length > 0) {
                    for (var i = 0; i < obj.length; i++) {
                        if (obj[i].id == searchVal)
                            return true;

                        if (obj[i].children != null && obj[i].children.length > 0) {
                            var result = this.recursiveSeach(obj[i].children, searchVal);

                            if (result) return true;
                        }
                    }
                }

                return false;
            },
            getBankStatementList() {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (this.arr_FV.BAI == null || this.arr_FV.BAI == "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BS"]["BA"]), 1000);
                        return;
                    }

                    if (path) {
                        path += "&";
                    }

                    path += "&f.BAI=" + this.arr_FV.BAI;

                    if (this.arr_FV.RS != null && this.arr_FV.RS != "") {
                        path += "&f.RS=" + this.arr_FV.RS;
                    }

                    if (this.arr_FV.MA != null && this.arr_FV.MA != "") {
                        path += "&f.MA=" + this.arr_FV.MA;
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        var trsd_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.TRSD_from=" + trsd_from;
                    }

                    if (this.arr_FV.DR.endDate != "") {
                        var trsd_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.TRSD_to=" + trsd_to;
                    }
                }

                this.bool_fullLoading = true;

                this.getDataApi(`/api/bankacc/lbs?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_BankStatement = (d.D && d.D.Items) || [];
                        }
                    });
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#30878e' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#e53636' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#6f6bd6' };
                }
            },
            AgentGroupChange(value) {
                this.bool_fullLoading = false;

                if (value != this.str_agi) {
                    this.loadBankAccount(false);
                }

                this.str_agi = value;
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                    endDate: this.getTodayEndDate()
                };
            },
            getMemberDepositClass(mb, ta, dmi, rs) {
                if (ta >= 0 && rs == 1) {
                    if (dmi != "") {
                        return "duplicated";
                    }
                    if (mb == null) {
                        return "notmatched";
                    }
                    else {
                        return "matched";
                    }
                }
                else {
                    return "withdrawal";
                }
            },
            getStatusList() {
                this.dd_status = [{ id: '1', label: this.getLanguage['MTA']['AC1'] }, { id: '2', label: this.getLanguage['MTA']['AC2'] }, { id: '3', label: this.getLanguage['MTA']['AC3'] }];
            },
        },
        created() {
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.ACL';

            var parameters = this.$route.query;
            if (parameters.bai !== undefined) {
                this.arr_FV.BAI = parameters.bai;
            }

            if (parameters.agi !== undefined) {
                this.arr_FV.AGI = "3-" + parameters.agi;
            }

            this.getDropdownList(true);
            this.setThousandCurrency(false);
            this.getStatusList();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Banks/BankStatement.vue